import { DANGER_COLOR, MAIN_COLOR } from "shared/consts";
import styled from "styled-components";

export type TColorText = 'outlined' | 'main' | 'danger';
export type TSize = 'default' | 'small' | 'medium';

const getColor = (type: TColorText = 'outlined', mode: TSize = 'default') => {
	switch (type) {
		case 'outlined':
			return { borderColor: MAIN_COLOR, background: 'transparent', visibility: mode === 'medium' ? 'visible' : 'hidden', opacity: mode === 'medium' ?  '1' : '0' };
        case 'main':
            return { borderColor: MAIN_COLOR, background: MAIN_COLOR, visibility: 'visible', opacity: '1' };
        case 'danger':
            return { borderColor: DANGER_COLOR, background: DANGER_COLOR, visibility: 'visible', opacity: '1' };
		default:
			return { borderColor: MAIN_COLOR, background: 'transparent', visibility: 'visible', opacity: '1' };
	}
};

const getSize = (type: TSize = 'default') => {
	switch (type) {
		case 'default':
			return { width: '70px', height: '24px' };
        case 'small':
            return { width: '34px', height: '20px' };
        case 'medium':
            return { width: '50px', height: '24px' };
		default:
			return { width: '70px', height: '24px' };
	}
};

export const ConfirmOrderButton = styled.div<{ $variant: TColorText, mode: TSize }>`
	display: flex;
    transition-duration: .2s;
    background-color: ${props => getColor(props.$variant).background};
    border-radius: 20px;
    min-width: ${props => getSize(props.mode).width};
    min-height: ${props => getSize(props.mode).height};
    max-height: ${props => getSize(props.mode).height};
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${props => getColor(props.$variant).borderColor};
    cursor: pointer;
    box-sizing: border-box;
    @media (any-hover: hover){
      opacity:  ${props => getColor(props.$variant, props.mode).opacity};
      visibility:  ${props => getColor(props.$variant, props.mode).visibility};
    }

    & > img {
        width: ${props => props.$variant === 'danger' ? '12px' : '16px'};
        height: ${props => props.$variant === 'danger' ? '12px' : '16px'};
    }
`;

export const ConfirmOrderButtonWrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
`;